import { render, staticRenderFns } from "./ProductWeight1.vue?vue&type=template&id=20a1d70f&scoped=true"
import script from "./ProductWeight1.vue?vue&type=script&lang=js"
export * from "./ProductWeight1.vue?vue&type=script&lang=js"
import style0 from "./ProductWeight1.vue?vue&type=style&index=0&id=20a1d70f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1d70f",
  null
  
)

export default component.exports